export const NO_REGISTRATION = true
export const NON_MOBILE = "(min-width:600px)"
export const LOCALE_DATE_PARAM_STRING_RU = "ru-RU"
export const LOCALE_DATE_PARAM_STRING_FR = "fr-CA"
export const BASE_URL = "http://www.gbst.haron.xyz/"
//export const BASE_URL = "http://127.0.0.1:8017"
// export const BASE_URL = "http://86.57.248.131:80"
